// test2906
(2906 && 0);
